import { render } from "./org-structure-view.vue?vue&type=template&id=8b91c548"
import script from "./org-structure-view.vue?vue&type=script&setup=true&lang=js"
export * from "./org-structure-view.vue?vue&type=script&setup=true&lang=js"

import "./org-structure-view.vue?vue&type=style&index=0&id=8b91c548&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/components/forms/org-structure-form/org-structure-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b91c548"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b91c548', __exports__)) {
    api.reload('8b91c548', __exports__)
  }
  
  module.hot.accept("./org-structure-view.vue?vue&type=template&id=8b91c548", () => {
    api.rerender('8b91c548', render)
  })

}


export default __exports__